module.exports = __webpack_public_path__ + "img/spring_100x100.69630870.png";